<script setup>
import { ref, onMounted, defineEmits, computed, watch } from "vue";
import Swal from "sweetalert2";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import axios from "axios";
const router = useRouter();
const store = useStore();
const type = ref("");

const type_list = ref([]);

const info = ref([]);

const load = ref(false);

const emits = defineEmits([
  "sbu_media_open",
  "sbu_media_name",
  "sbu_media_link",
  "sbu_media_class",
  "sbu_audio_open",
]);

function openMedia(index, _name_, _path_, _class_) {
  let path_s = `${store.state.s3_file}public/${type.value}/${_path_}`;

  console.log(index);
  console.log(_name_);
  console.log(path_s);
  console.log(_class_);

  info.value[type.value].forEach((item) => {
    item.open = false;
  });

  info.value[type.value][index].open = true;

  emits("sbu_media_open", true);
  emits("sbu_media_name", removeStartingStar(_name_));
  emits("sbu_media_link", removeStartingStar(path_s));
  emits("sbu_media_class", _class_);
  if (_class_ == "audio") {
    emits("sbu_audio_open", true);
  }
}

function transformInfoData(info) {
  const result = {};

  // 檢查是否有資料
  if (!info || Object.keys(info).length === 0) {
    console.log("沒資料");
    return
  }

  // 遍歷 info 對象的每個屬性
  Object.keys(info).forEach((key) => {
    if (info[key].length === 0) {
      console.log("沒資料");
      result[key] = [{ message: "此類別沒有資料" }];
    } else {
      result[key] = info[key].map((item) => {
        // 判斷檔案類型
        const extension = item.split(".").pop().toLowerCase();
        const fileType =
          extension === "mp4" ? "video" : extension === "mp3" ? "audio" : "other";

        return {
          name: item,
          path: item,
          pic: null,
          class: fileType,
          open: false,
        };
      });
    }
  });

  return result;
}

//判斷是不是空的
function isInfoEmpty(info) {
  // 遍歷 info 物件的每個 key
  for (let key in info) {
    if (info.hasOwnProperty(key)) {
      // 檢查是否有 __order 並且它是否是空的
      if (Array.isArray(info[key].__order) && info[key].__order.length === 0) {
        continue; // 如果是空陣列，跳過
      } else {
        return false; // 如果找到不是空的內容，返回 false
      }
    }
  }
  return true; // 如果所有 key 的 __order 都是空陣列，返回 true
}

function get_info() {
  // localStorage.getItem("public_link")

  // console.log(`${store.state.json_path}json/public.json`);
  axios
    .get(localStorage.getItem("public_link"))
    .then((res) => {

      if (res.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (res.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (res.status == 520) {
        get_info();
      }

      console.log(res.data);

      //資料獲取
      info.value = res.data.map;

      //標籤資料獲取
      type_list.value = res.data.map.__order;

      //目前篩選的目標
      type.value = type_list.value[0];

      delete info.value.__order;

      if(!isInfoEmpty(info.value)){
        info.value = transformInfoData(info.value);
      }

      load.value = true;

    })
    .catch((err) => {
      if (err.status == 520) {
        get_info();
      }
      console.log(err);
    });
}

const linkClass = computed(() => {
  // Check if info[type] is defined and has at least one item
  if (info.value[type.value] && info.value[type.value].length > 0) {
    return `link ${info.value[type.value][0].class}`;
  }
  return "link"; // Default class if info[type] is empty or not defined
});

const downloadFile = (url) => {
  const encodedUrl = encodeURIComponent(removeStartingStar(url));
  const link = document.createElement("a");
  link.href = `${store.state.s3_file}public/${encodeURIComponent(
    type.value
  )}/${encodedUrl}`;
  link.target = "_blank"; // 打開新窗口
  link.download = url;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// 判斷字串開頭是否是*
function startsWithStar(str) {
  return str.startsWith("*");
}

// 去除字串開頭的*
function removeStartingStar(str) {
  return str.startsWith("*") ? str.slice(1) : str;
}

const premium = ref(false);

function get_permissions() {
  const FormData = require("form-data");
  let data = new FormData();
  data.append("tch_account", localStorage.getItem("ac"));

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/teacher-info/get`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      console.log(response.data.data.series_permissions);

      if (response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }
      
      response.data.data.series_permissions.forEach((item) => {
        if (item.series_name == localStorage.getItem("unit")) {
          if (item.public == "premium") {
            premium.value = true;
          } else {
            premium.value = false;
          }
          return;
        }
      });

      // if (response.data.data.series_permissions[0].public == "premium") {
      //   premium.value = true;
      // } else {
      //   premium.value = false;
      // }
    })
    .catch((error) => {
      console.log(error);
      console.log(error.response.data.code);

      if (error.response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (error.response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }
    });
}

const filteredInfo = computed(() => {
  const result = {};

  // 當 premium 為 false 才過濾資料
  if (!premium.value) {
    for (const [category, items] of Object.entries(info.value)) {
      result[category] = items.filter((item) => !startsWithStar(item.name));
    }
  } else {
    // premium 為 true 時，直接返回原始資料
    Object.assign(result, info.value);
  }

  return result;
});

watch(
  () => type.value,
  () => {
    emits("sbu_audio_open", false);
  }
);
onMounted(() => {
  get_permissions();
  get_info();
});
</script>

<template>
  <div id="public">
    <div class="type" v-if="load && !isInfoEmpty(info)">
      <button
        @click="type = item"
        v-for="(item, index) in type_list"
        :key="index"
        :class="{ active: item == type }"
      >
        {{ item }}
      </button>
    </div>

    <div :class="linkClass" v-if="info && load&&!isInfoEmpty(info)">
      <div
        @click="openMedia(index, item.name, item.path, item.class)"
        class="item"
        v-for="(item, index) in filteredInfo[type]"
        :key="index"
        :class="{ [item.class]: true, active: item.open }"
      >
        <button v-if="item.class == 'audio'">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29.756"
            height="30"
            viewBox="0 0 29.756 30"
          >
            <g id="music-player" transform="translate(-2.083 0)">
              <g transform="translate(2.083 0)">
                <path
                  d="M31.373.331A1.351,1.351,0,0,0,30.3.014l-18.912,2.7a1.351,1.351,0,0,0-1.16,1.337V19.891a5.42,5.42,0,1,0,2.7,4.687V10.628L29.137,8.312V17.19a5.42,5.42,0,1,0,2.7,4.687V1.351A1.351,1.351,0,0,0,31.373.331Z"
                  transform="translate(-2.083 0)"
                  fill="#fff"
                />
              </g>
            </g>
          </svg>
          <span>{{ removeStartingStar(item.name) }}</span>
          <img
            v-if="startsWithStar(item.name)"
            class="premium"
            src="@/assets/images/premium.svg"
            alt="icon"
          />
        </button>

        <div v-if="item.class == 'video'" class="video_content">
          <img
            v-if="startsWithStar(item.name)"
            class="premium"
            src="@/assets/images/premium.svg"
            alt="icon"
          />
          <div class="pic">
            <img src="@/assets/images/video/video_pic.png" alt="pic" />
          </div>
          <h3>
            <span>
              {{ removeStartingStar(item.name) }}
            </span>
          </h3>
        </div>

        <div class="thead" v-if="item.class == 'other' && index == 0">
          <div class="tr">
            <div class="th">File Name</div>
            <div class="th">Download</div>
          </div>
        </div>

        <div
          v-if="item.class == 'other'"
          class="tbody"
          :class="{ even: index % 2 === 0 }"
        >
          <div class="tr">
            <div class="td">
              <img
                class="icon"
                src="@/assets/images/public/file.svg"
                alt="icon"
              />
              <span>{{ removeStartingStar(item.name) }}</span>
              <img
                v-if="startsWithStar(item.name)"
                class="premium"
                src="@/assets/images/premium.svg"
                alt="icon"
              />
            </div>
            <div class="td">
              <span v-if="!item.premium" @click="downloadFile(item.name)">
                <img
                  class="icon"
                  src="@/assets/images/public/download.svg"
                  alt="icon"
                />
              </span>
              <span v-else>
                <img
                  class="icon"
                  src="@/assets/images/public/premium.svg"
                  alt="icon"
                />
              </span>
            </div>
          </div>
        </div>

        
      </div>
    </div>

    <p v-if="isInfoEmpty(info)" style="font-size: 72px; color: #fff; font-weight: 700; position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%);">
      No Data
    </p>

    <div
      v-if="!load"
      style="
        position: absolute;
        width: 100%;
        height: 100%;
        margin: 0;
        border-radius: 25px;
      "
    >
      <h6
        style="
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 60px;
          text-shadow: 0 5px 12px #888;
        "
      >
        LOADING...
      </h6>
    </div>
  </div>
</template>
